// Question normalization for the Lab's exact-match mock lookup: a typed
// question must hit its mock entry regardless of case, punctuation ("?",
// straight vs curly apostrophes) or stray whitespace. Mock `aliases` are
// stored PRE-normalized; entry `question` fields are normalized at lookup.
export function normalizeQuestion(q) {
  return String(q || "")
    .toLowerCase()
    .replace(/['‘’]/g, "") // apostrophes vanish: dunkin' → dunkin
    .replace(/[^a-z0-9$% ]+/g, " ") // every other punctuation → space
    .replace(/\s+/g, " ")
    .trim();
}
